/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import React, { Fragment } from 'react';
import { spaceColumnContainer } from '../../styles';
import { IDailyViewProps } from '../../types';
import { spaceWidth } from '../styles';
import { CurrentTimeLine } from './CurrentTimeLine';
import { DayToDrop } from './DayToDrop';
import { useResources } from '../../hooks/useResources';

export const DailyViewVertical: React.FC<IDailyViewProps> = ({
	EventComponent,
	isModeChanged,
	onAddNewSlotClick,
	hourSize,
	isLoading,
	currentDate,
	resourceGroups,
}) => {
	const { resources, columnsCount } = useResources({ resourceGroups });

	return (
		<Fragment key="DailyViewVertical">
			{resources.map((resource, index) => {
				if (!resource.children.length) {
					return (
						<div
							key={`DailyViewVertical-Space-${resource.id}-${index}`}
							css={spaceColumnContainer(columnsCount, 1)}
							data-aid="DailyViewVertical-daily"
						>
							<DayToDrop
								id={String(resource.id)}
								EventComponent={EventComponent}
								withoutChildren
								isLoading={isLoading}
								isModeChanged={isModeChanged}
								onAddNewSlotClick={onAddNewSlotClick}
								currentDate={currentDate}
								activityTimes={resource.activityTimes}
							/>
						</div>
					);
				}

				return (
					<div
						key={`DailyViewVertical-DayToDrop-Wrapper-${resource.id}`}
						css={spaceColumnContainer(columnsCount, resource.children.length || 1)}
					>
						{resource.children.map(child => {
							return (
								<DayToDrop
									key={`DailyViewVertical-DayToDrop-Child-${child.id}`}
									id={String(child.id)}
									isLoading={isLoading}
									EventComponent={EventComponent}
									isModeChanged={isModeChanged}
									onAddNewSlotClick={onAddNewSlotClick}
									currentDate={currentDate}
									activityTimes={child.activityTimes}
								/>
							);
						})}
					</div>
				);
			})}
			<CurrentTimeLine width={columnsCount * spaceWidth} />
		</Fragment>
	);
};

DailyViewVertical.displayName = 'DailyViewVertical';
